import React, { useContext } from 'react';

import cx from 'classnames';

import { RECORD_LOCATOR, ROUTE } from 'components/Pages/Admin/GuestPortal/Flights/AddFlights/utils';
import CheckBox from 'components/shared/FormAdapters/FormDefault/CheckBox';
import { formatDateWithFullMonth } from 'utils/date';

import { FlightsContext } from '../../../context';
import s from './index.module.css';

const getTypeText = (enteredType) => {
  switch (enteredType) {
    case RECORD_LOCATOR:
      return 'Record Locator';
    case ROUTE:
      return 'Route';
    default:
      return null;
  }
};

function HeadText(props) {
  const { airline, departureTime, flightNumber, activeType } = props;
  const { dateFormat } = useContext(FlightsContext);
  const departureTimeFormat = formatDateWithFullMonth(new Date(departureTime), dateFormat);
  const additionalText = getTypeText(activeType);

  return (
    <>
      {additionalText && (
        <>
          <strong>{additionalText}</strong> matched with{' '}
        </>
      )}
      <strong>
        Flight {airline?.fsCode}
        {flightNumber}
      </strong>{' '}
      on <strong>{departureTimeFormat}</strong>
    </>
  );
}

export function Head({ item, activeType, setActiveItems, checked }) {
  return (
    <div className={cx(s.head, 'custom-add-flights-result-head')}>
      <CheckBox
        onChange={() => setActiveItems(item)}
        checked={checked}
        titleClassName={cx(s.checkbox, 'custom-add-flights-result-checkbox')}
      >
        <HeadText {...item} activeType={activeType} />
      </CheckBox>
    </div>
  );
}
